import { CONTINUOUS_EDUCATION } from '../../../api/endpoints';
import request from '../../../api/request';
import {
  CeAcademicOffer,
  CeAcademicOfferFilters,
  CeAcademicOfferFormData,
  CeAcademicOfferPaginatedResponse,
  CeAcademicOfferScheduleResponse,
  CeAcademicOfferStepEnum,
  CeAcademicOfferStepResponse,
  CeAcademicOfferSummaryResponse,
  CreateCeAcademicOfferPayload,
  PublishCeAcademicOfferPayload,
  UpdateCeAcademicOfferPayload,
} from './types';

/**
 * Obtiene los datos necesarios para el formulario de creación/edición
 */
export const getAcademicOfferFormData = () => {
  return request<CeAcademicOfferFormData>(
    CONTINUOUS_EDUCATION.ACADEMIC_OFFERS_FORM_DATA,
  );
};

/**
 * Obtiene el listado paginado de ofertas académicas de educación continua
 */
export const getAcademicOffers = (filters: CeAcademicOfferFilters = {}) => {
  return request<CeAcademicOfferPaginatedResponse>(
    CONTINUOUS_EDUCATION.ACADEMIC_OFFERS,
    {
      method: 'GET',
      params: filters,
    },
  );
};

/**
 * Obtiene una oferta académica por ID
 */
export const getAcademicOfferById = (id: number | string) => {
  return request<CeAcademicOffer>(CONTINUOUS_EDUCATION.ACADEMIC_OFFER(id));
};

/**
 * Crea una nueva oferta académica
 */
export const createAcademicOffer = (data: CreateCeAcademicOfferPayload) => {
  return request<CeAcademicOffer>(CONTINUOUS_EDUCATION.ACADEMIC_OFFERS, {
    method: 'POST',
    data,
  });
};

/**
 * Actualiza una oferta académica existente
 */
export const updateAcademicOffer = (
  id: number | string,
  data: UpdateCeAcademicOfferPayload,
) => {
  return request<CeAcademicOffer>(CONTINUOUS_EDUCATION.ACADEMIC_OFFER(id), {
    method: 'PUT',
    data,
  });
};

/**
 * Elimina una oferta académica
 */
export const deleteAcademicOffer = (id: number | string) => {
  return request(CONTINUOUS_EDUCATION.ACADEMIC_OFFER(id), {
    method: 'DELETE',
  });
};

/**
 * Obtiene el paso actual de una oferta académica de EC
 */
export const getAcademicOfferCurrentStep = (id: number | string) => {
  return request<CeAcademicOfferStepResponse>(
    CONTINUOUS_EDUCATION.ACADEMIC_OFFER_CURRENT_STEP(id),
  );
};

/**
 * Actualiza el paso actual de una oferta académica de EC
 */
export const updateAcademicOfferCurrentStep = (
  id: number | string,
  currentStep: CeAcademicOfferStepEnum,
) => {
  return request<CeAcademicOfferStepResponse>(
    CONTINUOUS_EDUCATION.ACADEMIC_OFFER_CURRENT_STEP(id),
    {
      method: 'PUT',
      data: { currentStep },
    },
  );
};

/**
 * Obtiene los datos de horarios agregados de una oferta CE
 */
export const getAcademicOfferScheduleData = (id: number | string) => {
  return request<CeAcademicOfferScheduleResponse>(
    CONTINUOUS_EDUCATION.ACADEMIC_OFFER_SCHEDULE(id),
  );
};

/**
 * Obtiene los datos del resumen de una oferta CE
 */
export const getAcademicOfferSummaryData = (id: number | string) => {
  return request<CeAcademicOfferSummaryResponse>(
    CONTINUOUS_EDUCATION.ACADEMIC_OFFER_SUMMARY(id),
  );
};

/**
 * Publica una oferta CE: completa los datos, activa la oferta y crea el proceso de admisión
 */
export const publishAcademicOffer = (
  id: number | string,
  data: PublishCeAcademicOfferPayload,
) => {
  return request<CeAcademicOffer>(
    CONTINUOUS_EDUCATION.ACADEMIC_OFFER_PUBLISH(id),
    {
      method: 'POST',
      data,
    },
  );
};
